var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 582.86 492.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-16,.cls-22,.cls-30,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#eba382;}.cls-4{stroke:#d69172;}.cls-16,.cls-4{stroke-miterlimit:10;}.cls-5{fill:#c8d3e8;}.cls-6{fill:#86848d;}.cls-7{fill:#696a73;}.cls-8{fill:#4d2117;}.cls-12,.cls-34,.cls-9{fill:#fff;}.cls-9{opacity:0.3;}.cls-10{fill:#133a50;}.cls-11,.cls-32,.cls-33{fill:#47506b;}.cls-13{fill:url(#linear-gradient);}.cls-14{fill:url(#linear-gradient-2);}.cls-15{fill:#33394d;}.cls-16{stroke:#33394d;stroke-width:0.99px;}.cls-17{fill:#bac7df;}.cls-18{fill:#99a0c9;}.cls-19{fill:#ced3eb;}.cls-20{fill:#d7d7d7;}.cls-21{fill:#ababab;}.cls-22{stroke:#dc3d47;stroke-width:5.67px;}.cls-22,.cls-30{stroke-linecap:round;stroke-linejoin:round;}.cls-23{fill:#dc3d47;}.cls-24{fill:#b5333c;}.cls-25{fill:#7fb1fc;}.cls-26{fill:#bfd2f3;}.cls-27{fill:#94c7c9;}.cls-28{fill:#f0c961;}.cls-29{fill:#f4b753;}.cls-30{stroke:#ee8b13;stroke-width:1.42px;}.cls-31{fill:#f0c75e;}.cls-32{font-size:61.23px;letter-spacing:-0.01em;}.cls-32,.cls-33{font-family:BebasNeueBold;}.cls-33{font-size:38.19px;letter-spacing:-0.01em;}.cls-34{font-size:23.58px;font-family:Montserrat-Bold, Montserrat;font-weight:700;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-29.02 -52.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -394.68,
    width: 1040,
    height: 500
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 346.47,
    y1: 250.17,
    x2: 407.72,
    y2: 250.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e0e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#cfd1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbc1df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 328.86,
    y1: 249.55,
    x2: 346.47,
    y2: 249.55,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.06,332.84c4.36-5.59,9-11,13.89-16.27-10.35-7.88-12-12.77-13.71-18.36-2.1-6.71-7.74-11.71-21.83-18.34S103,279.26,107,282.3s8.86,4.63,12.56,10.72-1.94,8.66-7.31,8.18-6.13-5.43-8.85-9.52c-1.7-2.55-4.22-2.75-5.74-1.15-.91,1-.53,3.72-.53,3.72-.77-3.25.16-9.91-1.55-13.23a3.84,3.84,0,0,0-4.9-2.09c-2.89,1.57-3.55,13.56-3.55,13.56a25.38,25.38,0,0,1-2-8.79c0-4.22-2.16-4.7-4.53-4.14s-4.66,8.8-4.66,8.8a38.11,38.11,0,0,0-7.6-5.67c-3.7-1.87-2.79,5.13-.41,8.8S81,300.34,88.6,306s23.16,9,32.5,12.5C125.14,320,132,325.53,140.06,332.84Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.62,285.26c-.06,2.71-.68,7.84.57,11.67a20.11,20.11,0,0,0,3.4,6.32",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.88,298.58a46.81,46.81,0,0,1,.2-13.79",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.54,293.34a6,6,0,0,1-.65-5c.9-2.77,1.69-4.77,1.69-4.77",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.78,322.4l-25-16.14-16.62,24.6,21.26,14.44S167.11,331.26,174.78,322.4Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M498.89,513.71c3-21.91,5.81-54.68,5.91-101.25C505,338.13,519,279.92,526,250c2.77-11.79,2.6-30.07-24.19-30.07H365.54s-58.67,104.94-66.36,140.9c-5.48,25.61-12.5,107.69-16.1,152.86Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M485.46,513.71c3-21.91,5.82-54.68,5.92-101.25.06-31.34,1.49-54.6,4.12-76.87a66.17,66.17,0,0,0-6.89-38.88c-4.76-8.94-8.21-25-3-53.49C489.56,222,496.33,220,496.33,220H352.11s-58.66,104.94-66.36,140.9c-5.47,25.61-12.5,107.69-16.09,152.86Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.16,177.42s2.65,44,4,46.68c3,6.05,30.89,22.63,30.89,22.63s-62.28,28.59-79.27,28.59-11-34.08-11-34.08,16.55-8.36,18.93-13.12c3.53-7.06,4.43-37.48,4.43-37.48Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M330.94,121.16c-8.42,6.8-10.69,18.15-9.37,25.86S328,172,328,172s6.83-26,11.11-35.12,11.25-21.1,11.25-21.1Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.28,120.46c-5.29,2.75-14.43,8.67-15.06,13.36s-3.22,18.41-2.93,26.54-1.76,23.87-.82,33.38,11.17,23.83,13.7,25.41c10.89,6.79,23.07.2,32.58-5.82,11.06-7,19.27-13.6,19.29-33.87,0,0,6.14-38.38,4.32-44-4.41-13.76-32.7-8.87-40.69-10.33S342.28,120.46,342.28,120.46Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.71,222c9.76.27,19.9-6.31,27.51-11.65",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M379.46,143.87c2.56,4.5,9.42,5.36,8.6,9.37-1.65,8-4.81,12.41-4.81,12.41l2.77,7.83s-1.81,1.88.89,10.13c1.48,4.49,24.74-15.37,21.22-38.63A27.72,27.72,0,0,0,394,124.51c-2-9.58-24-13.85-31.17-11.32-1.26.45-6.2-1.76-18.33.17-19.21,3.07-30.54,5.12-30.54,5.12,0,3.38,4,13.64,25.21,14.08s37.15,1.06,37.15,1.06A30.62,30.62,0,0,0,379.46,143.87Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M337.41,176.31c-1,3.38-2,5-7.63,4.92-6.29-.06-9.49-1.8-10.6-11.41-.52-4.43-.58-5.33.53-6.32s4.69-1.51,11.2-1.1,6.66.16,7.29,2.2C338.43,165.35,338.4,172.93,337.41,176.31Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M371.17,176.51c-1.08,5.23-5.27,5.82-11.45,5.82-6.46,0-8.44-2.52-9.54-6a20.5,20.5,0,0,1-.43-11.3c.77-2.12,3-2.17,9.71-2.31s10.4-.25,11.48.84S372.28,171.11,371.17,176.51Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.5,162.33c-.14-1.62-7.42-2.34-12.64-2.45s-14.05-.41-17.18.78-3.2,2.27-4.73,2.22-1.37-1.1-4.42-2.42-6.74-1-12-1.06c-2.61-.05-7.36-.17-9.26.23-1.54.33-1.33,1.9-1.1,4.48s.79,8.86,2.48,12.44C322,181.41,325,182,331,182.33c8.28.41,8.36-10.42,9.61-13.08s1.93-3,3.24-3,2.23.36,3.2,3.11c.64,1.81,1.65,13.75,10.48,14,9.46.26,12.9-1.39,14.9-6.36,1.54-3.84,1.51-9.44,2.5-10,.45-.24,3.05-.72,3.28-1.6A9.88,9.88,0,0,0,378.5,162.33ZM337,175.81c-1,3.08-1.56,5.47-7.24,5.42-6.29-.06-9.12-2.62-10.19-9.5-.68-4.41-1-7.24.12-8.23s4.69-1.51,11.2-1.1,6.66.16,7.29,2.2A38.1,38.1,0,0,1,337,175.81Zm33.59-.4c-1.07,5.23-4.71,7.14-10.89,6.92s-8.11-2.56-9.49-8.21a26.25,26.25,0,0,1-.48-9.13c.77-2.12,3-2.17,9.71-2.31s10.4-.25,11.48.84S371.72,170,370.61,175.41Zm23.47-12.36a32,32,0,0,0-9.06-2.26c-9.22-.54-12.59-.51-12.59-.51l5.78,5.17,12.35.65A12.93,12.93,0,0,1,394.08,163.05Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.12,176.13s2.54-6.51,6.92-10.59c3.69-3.44,9.07-3.35,10.28,2.33,1.46,6.91-4.81,11.09-5.28,15.1-.53,4.51-4,8.39-7.25,9.13Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M158.11,309.37l-14,30.81s54.33,37.06,90,59.05c15.43,9.52,25-1.19,26.44-2.35,13.82-11.11,64.63-56.64,64.63-56.64s6.66-54.5-6.42-69.22c-11.42-12.84-25-8.34-25-8.34l-56.6,75C209.71,332.53,158.11,309.37,158.11,309.37Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M403.4,493.67c.52-79.82,4.92-154.34,25.2-234.71L405.76,234,349,259l-19.18-17.74-26.5,29.1s-2.22,27.47-5,47.57c-1.92,14.06-2.64,115.82-2.9,175.76Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.72,269.42s-2.58,39.88-7.06,69c-2.73,17.8-2.07,45.82-2.07,50.06,0,5,10.67,19,10.67,19s15.19-13.63,15.92-18.16c.31-1.94-2.1-39-3.4-59.94-1.74-27.89-3.93-59.43-3.93-59.43Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "306.57 203.5 315.7 217.11 325.83 217.66 341.04 200.18 318.84 199.49 306.57 203.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M395.9,230.32c-4,4.76-11.74,8-22.94,12.56a209.17,209.17,0,0,1-26.49,8.49s8.38,14.41,16.16,18.64c0,0,6.55-.92,22.51-10.64,11.17-6.8,15.1-15.54,22.58-25.35Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M338.45,234.5s-1.45,12.88,8,16.87c0,0-3.69,8.92-11.65,13.24,0,0-8.73-18.24-5.05-23.37A18.93,18.93,0,0,1,338.45,234.5Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.55,240.13s-14.3,50.53-4.16,103.12c2.89,15,2.1,65.28,2.1,65.28s1.76,89.73-1.55,100.51-1.75,22.54-22.79,22.37c-20-.16-24.46-10.82-24.46-10.82s7-103.86,7.89-131.83,6.11-126.08,6.11-126.08Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M334.82,237.6s-5.59,14.8-5.59,22.1-2,44.76-1.82,71.35c.06,12.81,1,51.37,1,51.37s-15.64-61.27-17.29-69.76c-2.05-10.54-1.9-16.77-.39-21,1.58-4.44,9.82-12.48,9.82-12.48s-4-14.18-5.3-18.16,3.4-8.44,6.93-13.61C325.07,243.25,334.82,237.6,334.82,237.6Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M405.76,234s-26.84,51.44-30,66.86a433.69,433.69,0,0,0-9.09,80.31s-4.74,97.21.15,115.32c5.38,19.88,2.54,39.75,27.54,40.21,26.59.49,52.15-11.72,52.15-11.72V411.05c0-30.83-8.08-159.25-8.08-159.25Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M406.05,233.77s-26.25,34.74-30.81,46.28-7.2,42.08-8.59,101.14c0,0,6.3-32.82,12.61-46.44,9.06-19.51,14.17-29.5,13.55-32.6-.89-4.44-6.8-8.83-8.32-13.88,0,0,9.44-1.49,14.49-7.5s12.9-28,13.68-35S406.05,233.77,406.05,233.77Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 353.36,
    y: 388.92,
    width: 38.24,
    height: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 260.35,
    y: 388.92,
    width: 29.03,
    height: 6.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 259.18,
    y1: 320.71,
    x2: 263.03,
    y2: 241.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 362.92,
    cy: 114.43,
    rx: 12.47,
    ry: 17.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M393.46,182.36a30.37,30.37,0,0,1-19.16,17c-4.47,1.41-10.62,1.93-16.74,1.93,0,0-.14,1.93-3.75,1.85-4.18-.09-5-1.59-5-3.43,0-2.76,2.5-3.14,4.06-3.23,2.11-.12,4.35.66,4.48,2.17,0,0,8.77.62,15.46-1.32,7.3-2.12,15.64-8.94,18.63-16.58Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 365.33,
    cy: 114.43,
    rx: 12.47,
    ry: 17.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M390.15,166.74c0,4.76,2.68,8.62,6,8.62s6-3.86,6-8.62-2.68-8.62-6-8.62S390.15,162,390.15,166.74Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M394.75,152.93l-4.33,3-1.3-.92s.23-20.23-8.89-32.29-17.43-9.58-17.43-9.58-.18-1,1.34-1.55a25.21,25.21,0,0,1,8.85-.93C378.62,111.07,396.1,115,394.75,152.93Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M396.06,153.86,390.42,156s.27-22.7-8.85-34.76-17.43-9.58-17.43-9.58a19.1,19.1,0,0,1,10.19-2.48C380,109.52,397.4,115.9,396.06,153.86Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.87,298.13c-2.69-12.9-13.07-49.52-14-62.79-.59-8.38,2.64-13.35,6.71-23.74s3.52-17.28,3-24.41-.73-15.92-3.53-15.5-1.24,7.74-1.58,11.45a44.15,44.15,0,0,1-.55,6.93c-.55,2.42-.78,3-1,4.1.16-6.38.53-13.61.27-15.78-.67-5.73-3.21-13.22-5.77-12.17-2.94,1.19.33,7.7.47,14.47a81.17,81.17,0,0,1-1.27,12.53c.33-2.28-.44-6.63-.73-9-.41-3.44-3.33-11.15-4.26-13.19s-4.16-2.59-3.77,1.42c.15,1.55,2.39,8.17,2.54,10.23a38.93,38.93,0,0,1,1,5.67c.09,2.35-.65,3.59-.64,4.33-.26-.81-.84-8.59-1.11-9.4-.44-1.27-.87-2.46-1.23-3.29-2-4.57-3.2-6.39-5-4.82-1.07.92,1.08,7.68,1.85,10.86s-.52,15.52-.52,15.52c-.74,1.51-4.46,9.05-5.78,15.91-1.06,5.49,0,10.55.8,11.77,4.5,7.28.59,55.33,2.6,74.71,3.31,31.91,11.87,46,11.87,46l21.09-20.14C415.23,321.35,414.53,306.12,412.87,298.13Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M407.33,368.12c-15.68,2.32-26.51-23.52-30-50.51s.82-69.07.82-69.07,21.35-5.66,25.93-8.91c0,0,4.82,28.22,8.71,46.55s5,26.8,5,26.8",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.46,321.1c1.14-4.11,8.34-8.25,9-11.72,2.73-15,13.09-67.28,36-57.58,14.06,6,17.24,29.2,10.14,53.61-2.69,9.24-5.6,23.52-16,40.21C420.34,337.26,407,326,393.46,321.1Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M411.59,280.53c0-4,4.9-16.69,12.36-21",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M448.55,305.41c-11.49,39.26-25.55,60.4-41.22,62.71s-26.51-23.52-30-50.51.82-69.07.82-69.07,21.35-5.66,25.93-8.91c0,0,9.87,55,13.75,73.35",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M390,198c-.21-5.79-.14-12.62-2.6-18",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M395.65,196.32c-.21-5.8-.14-12.62-2.6-18",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.54,196.39c1-5.72,2.45-12.38,1.14-18.15",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M382.42,175.13c-1.53,2.08,1.85,10.86,1.85,10.86s.48,13.44-.52,15.52S378.52,215,378.52,215c-.55,2.43-2.4,7.88.25,14.2s2.11,18.62,2.11,18.62",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M349.92,428.94H311.73L273.54,295.32H297a7.92,7.92,0,0,1,7.46,5.27Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M339,428.94h-149L148.12,304.52a7,7,0,0,1,6.62-9.2H293.33a9.86,9.86,0,0,1,9.48,7.15Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 160.88,
    y: 373.6,
    width: 170.98,
    height: 9.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 331.86,
    y: 373.6,
    width: 85.49,
    height: 9.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 16.33,
    y: 381.17,
    width: 543.64,
    height: 19.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 354.75,
    y: 381.17,
    width: 214.46,
    height: 19.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    y: 400.5,
    width: 582.86,
    height: 91.53
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M547.79,76.65l.15.19c.53.66,1,1.33,1.5,2a62.64,62.64,0,0,1,9.9,21.32,63.54,63.54,0,0,1-10.47,53.33,63.74,63.74,0,0,1-11.22,11.68l-.7.56c-1.74,1.36-3.52,2.61-5.34,3.77a61,61,0,0,1-7.54,4.05,62.22,62.22,0,0,1-11.33,3.9,59.15,59.15,0,0,1-7.44,1.32c-1,.12-2.05.22-3.09.28A63.47,63.47,0,1,1,538.92,67.38c.73.64,1.46,1.29,2.18,2h0A61.39,61.39,0,0,1,547.79,76.65Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 497.83,
    cy: 115.77,
    r: 54.28,
    transform: "translate(87.84 404.19) rotate(-54.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M501.19,178.83l81.36-7.06a4.16,4.16,0,0,0,3.8-4.22l-.63-36a4.17,4.17,0,0,0-4.68-4L569.3,129l-.15-41.18a4.15,4.15,0,0,0-4.45-4.13l-53.44,3.76a4.15,4.15,0,0,0-3.65,2.82l-12.93,38.43a4.26,4.26,0,0,0-.22,1.54l2.21,44.62A4.17,4.17,0,0,0,501.19,178.83Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M489.47,162.19A47.88,47.88,0,1,1,531,80.46",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "502.13 27.87 501.67 28.38 502.16 28.35 502.13 27.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M502.35,112.23a5.75,5.75,0,1,1-8.06-1A5.73,5.73,0,0,1,502.35,112.23Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M498.06,120.12h0a4.49,4.49,0,0,1-4.8-4.15l-1.71-23.48a4.49,4.49,0,0,1,4.15-4.8h0a4.49,4.49,0,0,1,4.81,4.15l1.71,23.48A4.49,4.49,0,0,1,498.06,120.12Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M499.72,113.43h0a2.9,2.9,0,0,1-.41,4.08L474,138.19a2.9,2.9,0,0,1-4.08-.41h0a2.88,2.88,0,0,1,.41-4.08L495.63,113A2.9,2.9,0,0,1,499.72,113.43Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 513.51,
    y: 249.99,
    width: 62.7,
    height: 62.7,
    rx: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 524.85,
    y: 272.92,
    width: 12.47,
    height: 23.14,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M595.28,333.9a2.89,2.89,0,0,0-2.89-2.89,2.89,2.89,0,0,0,0-5.78H580.33a52.29,52.29,0,0,0,.12-9.09,2.77,2.77,0,0,0-2.77-2.78h-.1a2.8,2.8,0,0,0-2.77,2.51c-.19,1.73-.57,7.16-2.4,8a8.85,8.85,0,0,0-3.09,2.07,2.12,2.12,0,0,0-.35.48,1.68,1.68,0,0,0-.33,1.17V346a2.34,2.34,0,0,0,2.34,2.34h20.63v0h.78a2.89,2.89,0,1,0,0-5.78,2.89,2.89,0,1,0,0-5.78h0A2.89,2.89,0,0,0,595.28,333.9Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M103,146.38a21.13,21.13,0,1,0,21.13-21.12A21.13,21.13,0,0,0,103,146.38Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M111.58,143.43l8.11-6.48a.75.75,0,0,1,1.23.59v1.69a.57.57,0,0,0,.44.56c3.83.88,14.19,3.21,13.74,15-.06-.18-.55-5.95-13.58-6.61a.58.58,0,0,0-.6.57v1.73a.76.76,0,0,1-1.23.59l-8.11-6.48A.77.77,0,0,1,111.58,143.43Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M273.12,97.92C271.26,83.76,252,74,230.14,76.1S192,91.4,193.9,105.57c1.7,12.91,17.83,22.16,37.24,22.11a24.76,24.76,0,0,0,17.53,5.4,33.76,33.76,0,0,1-5.07-6.72C262,122.49,274.79,110.59,273.12,97.92Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M246.6,101a3.49,3.49,0,1,0,3.49-3.49A3.49,3.49,0,0,0,246.6,101Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M227.9,101a3.49,3.49,0,1,0,3.49-3.49A3.49,3.49,0,0,0,227.9,101Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M209.19,101a3.49,3.49,0,1,0,3.49-3.49A3.49,3.49,0,0,0,209.19,101Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M244.79,198.45v39.66a7.18,7.18,0,0,1-7.17,7.17H165.35a7.18,7.18,0,0,1-7.17-7.17V198.45a7.22,7.22,0,0,1,7.17-7.17h72.27a7.18,7.18,0,0,1,7.17,7.17Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M160.43,243.31l36.54-30a6.83,6.83,0,0,1,9,0l36.54,30a7.11,7.11,0,0,1-4.93,2H165.35A7.1,7.1,0,0,1,160.43,243.31Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M160.43,243.31l36.54-30a6.83,6.83,0,0,1,9,0l36.54,30",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M242.55,193.25l-36.54,30a6.85,6.85,0,0,1-9,0l-36.54-30a7,7,0,0,1,4.92-2h72.27A7.1,7.1,0,0,1,242.55,193.25Z",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M242.55,193.25l-36.54,30a6.85,6.85,0,0,1-9,0l-36.54-30",
    transform: "translate(-29.02 -52.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 241.94,
    cy: 196.84,
    r: 16.96,
    transform: "translate(-20.31 351.62) rotate(-80.73)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-32",
    transform: "matrix(1, -0.09, 0, 1, 478.59, 87.05)"
  }, "24"), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "matrix(1, -0.09, 0, 1, 455.62, 120.25)"
  }, "HOURS"), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(209.2 152.39) scale(1 1.01)"
  }, "!"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportB);
export default __webpack_public_path__ + "static/media/support-b.c629d9a3050ceac33b16f9fee186c3aa.svg";
export { ForwardRef as ReactComponent };